const $ = kendo.jQuery

function getGridColumns() {
  const columns = [
    {
      field: 'number',
      title: 'Number',
      locked: false,
      width: 82,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'client',
      title: 'Client',
      width: 182,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'description',
      title: 'Description',
      width: 282,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'product',
      title: 'Product',
      width: 82,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'leg',
      title: 'Leg',
      width: 62,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {
      field: 'maturityDate2',
      title: 'Maturity',
      width: 120,
      attributes: {
        style: 'text-align: right;',
      },
    },
    {
      field: 'counterparty',
      title: 'Counterparty',
      width: 100,
      attributes: {
        style: 'text-align: left;',
      },
    },
    {},
  ]

  return [...columns]
}

function getResponsible($container, options) {
  return new Promise(function(resolve, reject) {
    const dataSourceUrl = '/api/report/ExposureReport/getResponsibleWithExpiryOption'
    $.ajax({
      url: dataSourceUrl,
      data: options,
      success: function(response) {
        const responsible = response

        resolve(responsible)
      },
      error: function(error) {
        reject(error)
      },
    })
  })
}

function getCcyPair($container, options) {
  return new Promise(function(resolve, reject) {
    const dataSourceUrl = '/api/report/ExposureReport/getCcyPairWithExpiryOption'
    $.ajax({
      url: dataSourceUrl,
      data: options,
      success: function(response) {
        const ccyPair = response

        resolve(ccyPair)
      },
      error: function(error) {
        reject(error)
      },
    })
  })
}

async function renderClientContainers($container, options, renderLocation) {
  const responsible = await getResponsible($container, options)
  let parameters = new Object()
  parameters.clientId = +options.clientId
  parameters.asOfDate = options.asOfDate
  parameters.responsibleEmail = options.responsibleEmail
  parameters.analystEmail = options.analystEmail
  parameters.reconciledClient = options.reconciledClient

  for (const responsibleItem of Object.values(responsible)) {
    const responsibleKey = responsibleItem.key
    const responsibleEmail = responsibleItem.value
    $container.append('<h2 style="margin-top:14px">' + responsibleEmail + '</h2>')
    parameters.responsibleEmail = responsibleEmail
    const pair = await getCcyPair($container, parameters)
    await Promise.all(
      Object.values(pair).map(ccyPairItem => {
        const ccyPairId = ccyPairItem.key
        const ccyPairCode = ccyPairItem.value
        $container.append('<h2>' + ccyPairCode + '</h2>')
        $container.append('<div id="container_' + responsibleKey + ccyPairId + '"></div>')
        $container.append('<div class="page-break"/>')
        parameters.ccyPairId = ccyPairId
        const $clientContainer = $('#container_' + responsibleKey + ccyPairId, $container)
        return renderGrid($clientContainer, parameters, renderLocation)
      }),
    )
  }
}

function renderGrid($container, options, renderLocation) {
  return new Promise(function(resolve, reject) {
    const actionName = 'expiryOptionDataSource'
    const controllerName = 'ExposureReport'
    const dataSourceUrl = `/api/report/${controllerName}/${actionName}`

    $.ajax({
      url: dataSourceUrl,
      data: options,
      success: function(response) {
        const data = response
        const grid = $container
          .empty()
          .kendoGrid({
            navigatable: true,
            editable: false,
            scrollable: true,
            dataSource: {
              data: data,
              pageSize: 0,
              schema: {
                model: {
                  id: 'number',
                  number: {
                    type: 'string',
                  },
                  client: {
                    type: 'string',
                  },
                  description: {
                    type: 'string',
                  },
                  product: {
                    type: 'string',
                  },
                  leg: {
                    type: 'string',
                  },
                  maturityDate: {
                    type: 'date',
                  },
                  maturityDate2: {
                    type: 'string',
                  },
                  counterparty: {
                    type: 'string',
                  },
                },
              },
            },
            dataBound: function(e) {
              if (renderLocation === 'dashboard') {
                const items = e.sender.dataSource.data().length
                if (items == 0) {
                  e.sender.element.closest('.component').remove()
                }
                if (items > 25) {
                  e.sender.element.closest('.component').prepend('<div class="page-break"/>')
                }
              }

              resolve(grid)
            },
            filterable: false,
            sortable: false,
            pageable: false,
            columns: getGridColumns(),
          })
          .data('kendoGrid')
      },
      error: function(error) {
        reject(error)
      },
    })
  })
}

export default {
  render: async function($container, options, location = 'dashboard') {
    return await renderClientContainers($container, options, location)
  },
}
